import React, { useEffect } from 'react';
import useExportTaskManager from '@/hooks/useExportTaskManager';
import useDownloadTaskManager from '@/hooks/useDownloadTaskManager';

interface ExportTaskProviderProps {
    children: React.ReactNode;
}

/**
 * 导出任务提供者组件
 * 用于在应用根部初始化导出任务管理器和下载任务管理器
 */
const ExportTaskProvider: React.FC<ExportTaskProviderProps> = ({ children }) => {
    // 初始化导出任务管理器
    useExportTaskManager();
    // 初始化下载任务管理器
    useDownloadTaskManager();

    return <>{children}</>;
};

export default ExportTaskProvider;

